import type { ReactNode } from 'react';
import {
  entityName,
  entityString,
  type ChangeRequest,
  type ModerationEntity,
  type Translate,
} from '@/entities/moderation';
import { useBranchName } from '../../../model/use-branch-name';
import { useVendorName } from '../../../model/use-vendor-name';
import { InfoRow, ReviewSection } from '../review-modal-shell';
import { LocalizedRows } from './localized-rows';

/** A menu category as one column (Figma 616:19215 body): names + owner rows. */
export function CategorySnapshot({
  entity,
  request,
  t,
  verdictInfo,
}: {
  entity: ModerationEntity;
  request: ChangeRequest;
  t: Translate;
  verdictInfo?: ReactNode;
}) {
  const vendorName = useVendorName(
    request.merchant_id ?? entityString(entity, 'merchant_id'),
  );
  const branchId = entityString(entity, 'restaurant_id') || (request.restaurant_id ?? '');
  const branchName = useBranchName(branchId);

  return (
    <>
      <ReviewSection title={t('create.nameSection', 'Наименование категории')}>
        <LocalizedRows value={entityName(entity)} t={t} />
      </ReviewSection>
      <ReviewSection
        title={t('create.infoSection', 'Основная информация')}
        divider={false}
      >
        <dl className="flex flex-col gap-2.5">
          <InfoRow label={t('create.vendor', 'Мерчант')} value={vendorName} />
          {branchId !== '' && (
            <InfoRow label={t('promoCreate.branch', 'Филиал')} value={branchName} />
          )}
          {verdictInfo}
        </dl>
      </ReviewSection>
    </>
  );
}
